module.exports = window["popupMaker"]["registry"];